import { NextPage } from 'next'
import { SupportView } from '@components/support/SupportView'
import { KKContentItem } from '@api/content'
import TranslationsLoaderProvider from '@ui/components/TranslationLoader/TranslationsLoader'

interface SupportPageProps {
  tab: string
  content: KKContentItem[]
}
export const SupportPage: NextPage<SupportPageProps> = ({ tab, content }) => {
  return (
    <>
      <TranslationsLoaderProvider>
        <SupportView tab={tab} content={content} />
      </TranslationsLoaderProvider>
    </>
  )
}
